import { ApertureWindowElement } from "../Aperture";  
import { AppDownloadsElement } from "../../../FleetTracker/Features/Downloads";

export class DownloadsActivator { 
    public static show() { 
        document.body.insertAdjacentHTML("beforeend", `
            <${ApertureWindowElement.tag} title="App Downloads" width=400 height=800 center no-icon>
                <template>
                    <${AppDownloadsElement.tag} embedded></${AppDownloadsElement.tag}>
                </template>
            </${ApertureWindowElement.tag}>
        `);
    }
}